var map = {
	"./apoteca.svg": 2720,
	"./cofano.svg": 5329,
	"./cofarle.svg": 4023,
	"./cofarme.svg": 3944,
	"./cofas.svg": 1663,
	"./cofas_old.svg": 1929,
	"./color/apoteca.svg": 3780,
	"./color/cofano.svg": 7333,
	"./color/cofarle.svg": 419,
	"./color/cofarme.svg": 5636,
	"./color/cofas.svg": 2363,
	"./color/dfg.svg": 4910,
	"./color/farmathia.svg": 9676,
	"./color/nafarco.svg": 7891,
	"./color/novaltia.svg": 1881,
	"./color/unnefar.svg": 126,
	"./dfg.svg": 9978,
	"./farmathia.svg": 5016,
	"./nafarco.svg": 5535,
	"./novaltia.svg": 4749,
	"./unnefar.svg": 7421,
	"./vadefarma.svg": 8772
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3769;